<template>
  <WdsText class="tw-truncate">{{ displayDate }}</WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import useDate from '@/composables/useDate'

const props = withDefaults(
  defineProps<{
    date: string | null
    format?: string
    fallback?: string
  }>(),
  {
    format: 'YYYY-MM-DD',
    fallback: '--',
  },
)

const formattedDate = useDate(computed(() => props.date), props.format)
const { isValid, date: formattedDateValue } = formattedDate

const displayDate = computed(() => {
  try {
    return isValid.value ? formattedDateValue.value : props.fallback
  } catch (error) {
    return props.fallback
  }
})
</script>

<style scoped></style>
